function HomePageController(Auth, PageHeading, $window) {
	'ngInject';
	const vm = this;

	vm.sideBar = true;
	vm.logout = Auth.logout;
	vm.getPageHeading = PageHeading.getPageHeading;
	vm.getCurrentUser = Auth.getCurrentUser;

	if ($window.innerWidth < 980) {
		vm.sideBar = false;
	}

	if ($window.outerWidth < 768) {
		const sidebar = document.getElementById('sidebar');

		sidebar.setAttribute('style', 'height:' + screen.height + 'px');
	}
}

export default HomePageController;



/** WEBPACK FOOTER **
 ** ./client/private/private.controller.js
 **/